// eslint-disable-next-line
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { useEffect } from "react";
import Layout from "components/Layout";
import RouteWrapper from "./RouteWrapper";
import ServerErrorPage from "pages/ServerErrorPage";
import Dashboard from "pages/Dashboard";
import ManageOrders from "pages/ManageOrders";
import Addressees from "pages/Addressees";
import NewAddressees from "pages/NewAddressee";
import Correios from "pages/Correios";
import Home from "pages/Home";
import ExpiredSession from "pages/ExpiredSession";
import NotFound from "pages/NotFound";
import { getSubDomain, verAccessType } from 'components/shared/getUrl';

export default function AdminRoutes() {
  const history = useHistory();

  useEffect(() => {
    const handleURL = verAccessType(getSubDomain) ? "/correios" : "/home"
    const homePage = history.location.pathname === "/"
    homePage && <Redirect to={handleURL} />;
  }, []);

  return (
    <>
      <Switch>
        <RouteWrapper
          exact
          path="/dashboard"
          component={Dashboard}
          layout={Layout}
        />
        <RouteWrapper
          exact
          path="/encomendas"
          component={ManageOrders}
          layout={Layout}
        />
        <RouteWrapper
          exact
          path="/destinatarios"
          component={Addressees}
          layout={Layout}
        />
        <RouteWrapper
          exact
          path="/novodest"
          component={NewAddressees}
          layout={Layout}
        />
        <RouteWrapper
          exact
          path="/correios"
          component={Correios}
          layout={Layout}
        />
        <RouteWrapper
          exact
          path="/home"
          component={Home}
          layout={Layout}
        />
        <Route exact path="/sessao-expirada" component={ExpiredSession} />
        <Route exact path="/error" component={ServerErrorPage} />
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </>
  );
}
